// 빈 견적 엑셀 양식 — 머리글은 견적 「엑셀 가져오기」 가 그대로 읽는 이름이다(tests/tools-quote-template.test.ts 가 왕복으로 지킨다).

import type * as XLSXModule from "xlsx";

type Xlsx = typeof XLSXModule;

export const QUOTE_TEMPLATE_HEADERS = [
  "공종",
  "공간",
  "부위",
  "작업내역",
  "단위",
  "수량",
  "자재 단가",
  "노무 단가",
  "비고",
] as const;

export const QUOTE_TEMPLATE_EXAMPLES: readonly (readonly (string | number)[])[] = [
  ["철거 공사", "거실", "바닥", "기존 바닥재 철거", "평", 32, 0, 15000, "예시 줄 — 지우고 쓰세요"],
  ["타일 공사", "욕실", "벽", "벽 타일 시공", "M2", 24, 18000, 12000, ""],
  ["도배 공사", "침실", "벽·천장", "실크 벽지", "롤", 18, 9000, 6000, ""],
];

export const QUOTE_TEMPLATE_FILE_NAME = "빌드파이_견적양식.xlsx";
export const QUOTE_TEMPLATE_ASCII_NAME = "buildpy-quote-template.xlsx";

export const quoteTemplateRows = (): (string | number)[][] => [
  ["인테리어 공사 견적서"],
  ["현장명:", "", "", "견적일:"],
  [...QUOTE_TEMPLATE_HEADERS],
  ...QUOTE_TEMPLATE_EXAMPLES.map((row) => [...row]),
];

export const quoteTemplateBytes = (xlsx: Xlsx): Uint8Array => {
  const sheet = xlsx.utils.aoa_to_sheet(quoteTemplateRows());
  sheet["!cols"] = [14, 8, 10, 24, 6, 6, 10, 10, 20].map((wch) => ({ wch }));
  const book = xlsx.utils.book_new();
  xlsx.utils.book_append_sheet(book, sheet, "견적");
  return new Uint8Array(xlsx.write(book, { type: "array", bookType: "xlsx" }) as ArrayBuffer);
};
